import React, { Component } from "react";
import { connect } from "react-redux";
import { Dimmer, Icon, Image, Modal } from "semantic-ui-react";
import { closeModal } from "../../redux/Modals/ModalActions";
import { PrimaryChip } from "../UI/CustomButtons";
import { AppColumn, AppRow } from "../UI/Layouts";
import { SizedBox } from "../UI/Sizes";
import { withOpacity } from '../../utils/helperFunctions';
import AppText from "../UI/Texts/AppTexts";

export const MODAL_MEDIA_VIEW = "MediaViewModal";

const mapStateToProps = (state) => {
  return {
    deviceDetails: state.core.deviceDetails,
    theme: state.theme,
  };
};

class MediaViewModal extends Component {
  state = {
    currentIndex: 0,
  };

  componentDidMount() {
    const { currentIndex } = this.props;
    this.setState({
      currentIndex: currentIndex ?? 0,
    });


  }


  onChange = (index) => {
    this.setState({
      currentIndex: index
    });
  }

  goBack = () => {
    const index = this.state.currentIndex;

    if (index > 0) {
      this.setState({
        currentIndex: index - 1
      });
    }
  }

  goNext = () => {
    const { images } = this.props;
    const index = this.state.currentIndex ?? 0;

    if (images && index < (images.length - 1)) {
      this.setState({
        currentIndex: index + 1
      });
    }
  }

  render() {
    const { deviceDetails, images, closeModal, theme } = this.props;
    const { isMobile } = deviceDetails || { isMobile: false };
    const { currentIndex } = this.state;
    const photos = images || [];


    return (
      <div>
        <Dimmer active />
        <Modal
          open={true}
          closeOnEscape={true}
          closeOnDimmerClick={true}
          style={{
            margin: '0',
            padding: theme.spacing.contentElementPadding,
            top: '0',
            height: '100%',
            width: '100%',
            marginTop: '0px',
            backgroundColor: theme.colors.dark,
            transform: 'none',
            justifyContent: 'center',
            alignItems: "center",
          }}
        >
          <AppRow mainAxisAlignment={'space-between'} style={{
            width: '100%'
          }}>
            <AppRow crossAxisAlignment={'center'} onClick={() => {
              closeModal(MODAL_MEDIA_VIEW);
            }} style={{
              cursor: 'pointer'
            }}>
              <Icon name="close" style={{
                color: theme.colors.white
              }} />
              <SizedBox width={theme.spacing.elementPaddingSmall} />
              <AppText.Footnote color={theme.colors.white}>Close</AppText.Footnote>
            </AppRow>
            <AppText.Caption color={theme.colors.white}>
              {photos.length > 0 ? `${currentIndex + 1}/${photos.length}` : 'No Images'}
            </AppText.Caption>
            <SizedBox width={'50px'} />
          </AppRow>

          <AppColumn crossAxisAlignment={'center'} mainAxisAlignment={'center'} style={{
            height: '100%',
          }}>
            <AppColumn mainAxisAlignment={'center'} style={{
              height: isMobile ? '100%' : '70vh',
              width: isMobile ? '100%' : '70%',
              borderRadius: theme.radius.default,
              overflow: 'hidden'
            }}>
              {photos && photos.length > 0 ? (<>
                <div style={{
                  position: 'relative',
                  width: '100%',
                }}>
                  <Image
                    src={photos[currentIndex]}
                    onClick={() => {
                      if(currentIndex < photos.length - 1) {
                        this.goNext();
                      }else{
                        this.setState({ currentIndex: 0 });
                      }
                    }}
                    loading='lazy'
                    alt={`Image ${currentIndex + 1}`}
                    style={{
                      cursor: 'pointer',
                      // 1200x675 aspect ratio
                      aspectRatio: '16/9',
                      objectFit: 'cover',
                      backgroundColor: withOpacity(theme.colors.grey, '0.1'),
                      borderRadius: theme.radius.default,
                      width: '100%',
                      height: '100%'
                    }}
                  />
                  <div style={{
                    position: 'absolute',
                    bottom: '20px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px'
                  }}>
                    {photos.map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => this.setState({ currentIndex: idx })}
                        style={{
                          width: '12px',
                          height: '12px',
                          borderRadius: '50%',
                          background: idx === currentIndex ? theme.colors.white : withOpacity(theme.colors.white, '0.5'),
                          border: 'none',
                          cursor: 'pointer'
                        }}
                      />
                    ))}
                  </div>
                </div>
              </>
              ) : (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  color: theme.colors.white
                }}>
                  <AppText.Body color={theme.colors.white}>No images to display</AppText.Body>
                </div>
              )}
            </AppColumn>
          </AppColumn>

          {!isMobile && photos.length > 0 && (
            <div style={{
              bottom: '50%',
              width: '96%',
              position: 'absolute',
            }}>
              <AppRow mainAxisAlignment={'space-between'}>
                <PrimaryChip secondary icon={'arrow left'} onClick={this.goBack} />
                <PrimaryChip secondary icon={'arrow right'} onClick={this.goNext} />
              </AppRow>
            </div>
          )}
        </Modal>
      </div>
    );
  }
}

export default connect(mapStateToProps, {
  closeModal
})(MediaViewModal);